
<div class="web-view" 
fxHide.xs fxHide.sm   fxHide.lt-md fxFlex.md > 

    <div class="navbar-div">
        <app-web-navbar></app-web-navbar>
    </div>

    <div fxLayoutAlign="center">
        <p class="host-heading">How To Host Screening Parties</p>
    </div>

    <div class="spotlight-div event-div" fxLayout="row">

        <div class="event-image-div"  fxLayout="row" fxLayoutAlign="center">
            <img class="event-image" src="assets/images/screening-parties/Slider1.png" alt="Slider1 Image">
        </div>

        <div class="event-details-div" fxLayout="row wrap"  fxLayoutAlign="start center" >
            <p class="event-heading" >Creating a Party</p>
            <!-- <ul class="event-details" >
                <li>On the Host screening party from select your Showcase Or Spotlight Event of choice.</li>
                <li>Before submitting, set up zoom conferance meeting for the screening party ahead of time (refer to the next section for details) You can use the livite link for this meeting to input the form and to share with your friends and family.</li>
                <li>Be sure to go over the code of conduct and instructional host training video!</li>
            </ul> -->
            <ul class="event-details">
                <li class="before">Fill out the easy <a style="color: white" href="/cinejoy/screening-parties/getting-started">Host Screening Party Form</a></li>
                <li class="before">You will need to set up zoom meeting or a <a style="color: white" href="https://www.gather.town/"> gather.town </a>
                    event for the screening party as part of this signup (refer 
                    to the next section for details). You will need to enter the 
                    meeting/event “Invite Link” (the full url that does not 
                    require a password).</li>
                <li class="before"> After you complete the Signup you will receive an 
                    invitation that you can forward to your community, or you can just send them the Invite Link. 
                    The idea is for you to fill half of your Party with people you know and for Cinejoy to bring the 
                    rest. This is the fun and excitement of introducing great people to each other around a shared 
                    movie or event experience, and to drive support for the great film artists who are shocasing 
                    their new work on Cinejoy.
                </li>
                <li class="before">
                    Try not to change your meeting as it will inconvenience 
                    people, but in case of emergency you can <a style="color: white" href="/cinejoy/screening-parties/join"> edit your Party here </a>(up to two times).

                </li>
            </ul>
        </div>

    </div>


    <div class="showcase-div event-div" fxLayout="row">


        <div class="event-details-div" fxLayout="row wrap"  fxLayoutAlign="start center" >
            <p class="event-heading" >Setting up a Zoom meeting for the Party</p>
            <ul class="event-details" >
                <li class="before">Sign in to your Zoom account.</li>
                <li class="before">Click "Schedule" to schedule a meetinf fot your future screening party</li>
                <li class="before">Be sure to fill out this important details</li>
                <li class="before">Enter the full Zoom Invite link into the form not the meeting Id, this link dose not require a password if set up as above
                    The topic should include the movie you are hosting for
                    make the date and time corelated with your cinejoy from
                    uncheck the waiting room option
                    check the option to allow participants to join anytime</li>
            </ul>
        </div>

        <div class="event-image-div"  fxLayout="row">
            <img class="event-image" src="assets/images/screening-parties/Slider2.png" alt="Showcase Image">
        </div>       
    </div>
    <p class="zoom"> Zoom Invite Links (not requiring a password) look like this:<br>
        https://us02web.zoom.us/j/85176508909?pwd=TTVqYUc3eHE4b772RvQTM5eWs5WSt655</p>
    <div class="screeningParties-div event-div" fxLayout="row">

        <div class="event-image-div"  fxLayout="row">
            <img class="event-image" src="assets\images\screening-parties\gathertown.PNG" alt="Screening Parties Image">
        </div>

        <div class="event-details-div" fxLayout="row wrap"  fxLayoutAlign="start center" >
            <p class="event-heading" > Setting up a Gather.Town event for the Party</p>
            <ul class="event-details" >
               <div>
                <a style="color: white" href="https://www.gather.town/"> gather.town </a> is a video chat platform designed to make virtual 
                interactions more human. This is a leading-edge alternative to 
                hosting your party on Zoom and provides an avatar-meets video 
                chat—meets virtual environment for your party. Here’s a few key 
                links to help you set up your party space and party event. When 
                done you will generate a url (similar to the Zoom invite link) that 
                goes into the signup field. 
                <P></P>
             <p>  About Gather: <a style="color: white" href="https://www.gather.town/about"> <br>
                https://www.gather.town/about</a> </p>
              <p>  Getting Started: <a style="color: white" href="https://app.gather.town/get-started"> <br>
                https://app.gather.town/get-started</a></p>
              <p>  Creating and event space: <a style="color: white" href="https://support.gather.town/help/create-a-space"><br>
                 https://support.gather.town/help/create-a-space</a></p>
                
             <p>   Sharing your event: <a style="color: white" href="https://support.gather.town/help/share-space"><br>
                 https://support.gather.town/help/share-space</a></p>
               
                </div>
            </ul>
        </div>

    </div>
    <div class="screeningParties-div event-div" fxLayout="row">

        <div class="event-details-div" fxLayout="row wrap"  fxLayoutAlign="start center" >
            <p class="event-heading" >Inviting People and Running The Party</p>
            <ul class="event-details" >
                <li class="before">Invite your community to your Screening Party. Please fill 
                    approximately 50% of your Party with people you know. 
                    Use your own text and links or use the Invitation PDF that 
                    will be generated for you to download upon completion of 
                    filling out the Host Form.</li>
                <li class="before">Mark you calendar and make sure to begin your Zoom or 
                    Gather Meeting/Event on the designated date/time.</li>
                <li class="before">Welcome people. Engage conversation around the movie. Introduce people. Use breakout rooms to encourage people to further meet and engage. Click here for breakout room setup info</li>
                <li class="before">Have Fun And enjoy the screening party !</li>

                
            </ul>
        </div>
        <div class="event-image-div"  fxLayout="row">
            <img class="event-image" src="assets/images/screening-parties/Slider3.png" alt="Screening Parties Image">
        </div>


    </div>

    <div class="btn-div" fxLayoutAlign="center" >

        <button (click)="gotoHostPage()" class="btn-exit">Exit</button>

    </div>

    <div class="footer-div" > 
        <app-cinejoy-footer></app-cinejoy-footer>
    </div>


</div>
                            <!-- wev view ended -->

                         <!-- mobile view started -->

<div class="mobile-view" 
                            fxHide.lg 
                            fxHide.md 
                            fxHide.lt 
                            fxFlex.lt-md
                            fxShow.xs  
                            fxHide.gt-lg >

    <div class="mobile-navbar">
        <app-sidebar></app-sidebar>
    </div>

    <div class="navbar-div">
        <app-web-navbar></app-web-navbar>
    </div>

<div fxLayoutAlign="center">
    <p class="host-heading-mob">How To Host Screening Parties</p>
</div>

    <div class="spotlight-div-mob event-div-mob" fxLayout="column"  >

        <div class="event-image-div-mob" fxLayout="column" fxLayoutAlign="center">
            <img class="event-image-mob" src="assets/images/screening-parties/Slider1.png" alt="Slider1 Image">
        </div>

        <div class="event-details-div-mob" fxLayout="column"  fxLayoutAlign="start" >
            <p class="event-heading-mob">
                Creating a party
            </p>
            <ul class="event-details-mob">
                <li class="before">Fill out the easy <a style="color: white" href="/cinejoy/screening-parties/getting-started">Host Screening Party Form</a></li>
                <li class="before">You will need to set up zoom meeting or a <a style="color: white" href="https://www.gather.town/"> gather.town </a>
                    event for the screening party as part of this signup (refer 
                    to the next section for details). You will need to enter the 
                    meeting/event “Invite Link” (the full url that does not 
                    require a password).
                </li>
                <li class="before">After you complete the Signup you will receive an 
                    invitation that you can forward to your community, or you can just send them the Invite Link. 
                    The idea is for you to fill half of your Party with people you know and for Cinejoy to bring the 
                    rest. This is the fun and excitement of introducing great people to each other around a shared 
                    movie or event experience, and to drive support for the great film artists who are shocasing 
                    their new work on Cinejoy.</li>
                    <li class="before">
                        Try not to change your meeting as it will inconvenience 
                        people, but in case of emergency you can <a style="color: white" href="/cinejoy/screening-parties/join"> 
                            edit your Party here </a>(up to two times).
                    </li>
            </ul>
        </div>

    </div>


    <div class="showcase-div-mob event-div-mob" fxLayout="column" >

        <div class="event-image-div-mob" fxLayout="column" fxLayoutAlign="center">
            <img class="event-image-mob" src="assets/images/screening-parties/Slider2.png" alt="Slider2 Image">
        </div>
        <p class="zoom-mob"> Zoom Invite Links (not requiring a password) look like this:<br>
            https://us02web.zoom.us/j/85176508909?pwd=TTVqYUc3eHE4b772RvQTM5eWs5WSt655/</p>
           

        <div class="event-details-div-mob" fxLayout="column"  fxLayoutAlign="start" >
            <p class="event-heading-mob">
               Setting up a Zoom meeting for the party 
            </p>
            <ul class="event-details-mob">
                <li class="before">Sign in to your Zoom account.</li>
                <li class="before">Click "Schedule" to schedule a meeting for your future screening party</li>
                <li class="before">Be sure to fill out this important details</li>
                <li class="before">Enter the full Zoom Invite link into the form not the meeting Id, this link dose not require a password if set up as above
                    The topic should include the movie you are hosting for
                    make the date and time corelated with your cinejoy from
                    uncheck the waiting room option
                    check the option to allow participants to join anytime</li>
            </ul>
        </div>
    </div>
     

         <div class="screeningParties-div event-div-mob" fxLayout="column ">

            <div class="screeningParties-div-mob event-div-mob" fxLayout="column">
                <div class="event-image-div-mob" fxLayout="column" fxLayoutAlign="center">
                <img class="event-image-mob" src="assets\images\screening-parties\gathertown.PNG" alt="Screening Parties Image">
            </div>
    
            <div class="event-details-div-mob" fxLayout="column"  fxLayoutAlign="start" >
                <p class="event-heading-mob">
                     Setting up a Gather.Town event for the Party
                    </p>
                
                    <div class="gather-mob">
                       <p> <a style="color: white" href="https://www.gather.town/"> gather.town 
                        </a> is a video chat platform designed to make virtual 
                        interactions more human. This is a leading-edge alternative to 
                        hosting your party on Zoom and provides an avatar-meets video 
                        chat—meets virtual environment for your party. Here’s a few key 
                        links to help you set up your party space and party event. When 
                        done you will generate a url (similar to the Zoom invite link) that 
                        goes into the signup field. </p><br>
                       <p></p>
                       
                    <p> About Gather: <a class="url" style="color: white" href="https://www.gather.town/about"><br>
                         https://www.gather.town/about</a></p>
                    <p> Getting Started: <a class="url" style="color: white" href="https://app.gather.town/get-started"> <br>
                        https://app.gather.town/get-started</a></p>
                    <p> Creating and event space: <a class="url" style="color: white" href="https://support.gather.town/help/create-a-space"><br>
                         https://support.gather.town/help/create-a-space</a></p>
                    <p> Sharing your event: <a class="url" style="color: white" href="https://support.gather.town/help/share-space"> 
                        <br>https://support.gather.town/help/share-space</a></p>
                       
                        </div>
                
            </div>
    
        </div>
    </div>

        <div class="screeningParties-div event-div-mob" fxLayout="column">

    <div class="screeningParties-div-mob event-div-mob" fxLayout="column">
        <div class="event-image-div-mob" fxLayout="column" fxLayoutAlign="center">
            <img class="event-image-mob" src="assets/images/screening-parties/Slider3.png" alt="Slider3 Image">
        </div>

        <div class="event-details-div-mob" fxLayout="column"  fxLayoutAlign="start" >
            <p class="event-heading-mob">
                Inviting People and Running The Party
            </p>
            <ul class="event-details-mob">
                <li class="before">Invite your community to your Screening Party. Please fill 
                    approximately 50% of your Party with people you know. 
                    Use your own text and links or use the Invitation PDF that 
                    will be generated for you to download upon completion of 
                    filling out the Host Form.</li>
                <li class="before">Mark you calendar and make sure to begin your Zoom or 
                    Gather Meeting/Event on the designated date/time.</li>
                <li class="before">Welcome people. Engage conversation around the movie. Introduce people. Use breakout rooms to encourage people to further meet and engage. Click here for breakout room setup info</li>
                <li class="before">Have Fun And enjoy the screening party !</li>
            </ul>
        </div>

    </div>

    <div class="btn-div" fxLayoutAlign="center">
        <button (click)="gotoHostPage()" class="btn-exit-mob">Exit</button>
    </div>



    <div class="footer-div">
        <app-cinejoy-mobile-footer></app-cinejoy-mobile-footer>
    </div>
    
</div>